// extracted by mini-css-extract-plugin
module.exports = {"image":"_1-6YJ","filter-effect-svg":"_1b5KK","filterEffectSvg":"_1b5KK","shapeCrop":"_2tOYG"};